export default "__VITE_ASSET__378b6f1d__"